export enum PurchaseOrderProgressStep {
	Info,
	Validate,
	EnterServiceDate,
	Ship,
	ValidateDelivery,
	DeliveryDetails,
	Invoice
}